import { DrawbackItem } from "@definitions/types"
import CustomerAttention from "@public/images/drawbacks/Customers-Attention.jpg"
import DataToCapture from "@public/images/drawbacks/Data-to-Capture.jpg"
import EnvironmentalHazard from "@public/images/drawbacks/Environmental-Hazard.jpg"
import PrintingCosts from "@public/images/drawbacks/Printing-Costs.jpg"
import ProtectiveCovers from "@public/images/drawbacks/Protective-Covers.jpg"
import SpecialsBoard from "@public/images/drawbacks/Specials-Board.jpg"
import Unhygienic from "@public/images/drawbacks/Unhygienic.jpg"
import UpdatingIsExpensive from "@public/images/drawbacks/Updating-is-Expensive.jpg"

export const DrawbacksList: DrawbackItem[] = [
  {
    image: CustomerAttention,
    description: "customer_attention",
  },
  {
    image: SpecialsBoard,
    description: "specials_board",
  },
  {
    image: UpdatingIsExpensive,
    description: "updating_is_expensive",
  },
  {
    image: Unhygienic,
    description: "unhygienic",
  },
  {
    image: ProtectiveCovers,
    description: "protective_covers",
  },
  {
    image: DataToCapture,
    description: "data_to_capture",
  },
  {
    image: PrintingCosts,
    description: "printing_costs",
  },
  {
    image: EnvironmentalHazard,
    description: "environmental_hazard",
  },
]
